import React from "react";
import ScrollToTop from "react-scroll-to-top";
import { FaArrowUp } from "react-icons/fa";
import { primaryColor } from "../constants/colors";

const ScrollToTopArrow = () => {
  return (
    <>
      <ScrollToTop
        smooth
        className="scroll-to-top"
        style={{
          bottom: "20px",
          right: "20px",
          backgroundColor: primaryColor,
          height: "50px",
          width: "50px",
          borderRadius: "50%",
        }}
        component={<FaArrowUp color="#fff" />}
      />
    </>
  );
};

export default ScrollToTopArrow;
